import React from "react";
import Select from "react-select";

const accessibleSelectStyles = {
  placeholder: (base) => ({ ...base, color: "#595959" })
};

export const ReactSelectAdapter = ({ input, disabled, defaultValue, required, styles: userStyles = {}, ...rest }) => {
  if (disabled) {
    return <span className='form-control-plaintext mb-4'>{input.value.label}</span>;
  } else {
    return (
      <Select
        {...input}
        {...rest}
        isSearchable
        aria-required={required || undefined}
        styles={{ ...accessibleSelectStyles, ...userStyles }}
      />
    );
  }
};
